<div class="checkbox-container">
  <input
    [ngModel]="tickBox.checked"
    (ngModelChange)="updateTickItem($event)"
    type="checkbox"
    [id]="id"
    class="tickbox-styled-checkbox"
  />
  <label [for]="id">
    {{ tickBox.name }}
    @if (tickBox.date && tickBox.checked) {
    <span>
      &nbsp;<date-time [iso]="tickBox.date"></date-time> &nbsp;(<relative-time
        [iso]="tickBox.date"
      ></relative-time
      >)
    </span>
    }
  </label>
</div>
